"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable react/button-has-type */
const react_1 = __importDefault(require("react"));
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const Tab_module_scss_1 = __importDefault(require("./Tab.module.scss"));
function Tab({ id, value, label, active = false, onClick = () => {
    /* do nothing */
}, }) {
    var _a;
    const clickHandler = () => {
        onClick(value);
    };
    const disableFeatures = (_a = Viewer_1.default.instance.getDesignProMain()) === null || _a === void 0 ? void 0 : _a.disableFeatures;
    return (react_1.default.createElement("button", { "data-active": active, className: Tab_module_scss_1.default['tab'], key: `${label}${id}`, onClick: clickHandler, disabled: disableFeatures, "aria-disabled": disableFeatures },
        react_1.default.createElement("div", { className: Tab_module_scss_1.default['content'] }, label),
        react_1.default.createElement("div", { className: Tab_module_scss_1.default['highlight'] })));
}
exports.default = Tab;
